<ion-row>
	@for (option of optionGroup.articles; track option; let optionIndex = $index) {
		@if (showFirstArticles ? optionIndex < 5 : true) {
			@if (!hasEmptyTag(option)) {
				<ion-item class="ion-text-wrap ion-no-padding" lines="none" mode="md">
					@if (option?.assets.medium) {
						<ion-img [src]="option?.assets?.medium" class="item-img"></ion-img>
					}
					@if (!option?.assets.medium) {
						<ion-img class="item-img" src="../../../assets/topgolf/header_logo.svg"></ion-img>
					}
					<ion-label>
						{{ option.name | langObservable | async }}
					</ion-label>
					<ion-row class="ion-no-margin ion-justify-content-between qty-row place-items-center" slot="end">
						<ion-row class="qty place-items-center">
							@if (getPrice(option, ot.STANDARD, preorderType) > 0 && currency) {
								<span class="font-12 main-color price"
									>+{{ numberToCurrency(getPrice(option, ot.STANDARD, preorderType), currency) }}</span
								>
							}
							<ion-fab-button
								(click)="decreaseOption(option)"
								[class.hidden]="count(option) <= 0"
								class="qty__btn"
								color="primary"
								size="small"
							>
								<span>-</span>
							</ion-fab-button>
							<span class="qty-number">{{ count(option) }}</span>
							<ion-fab-button
								(click)="increaseOption(option)"
								[class.hidden]="totalCount() >= optionGroup.limit"
								class="qty__btn"
								color="primary"
								size="small"
							>
								<span>+</span>
							</ion-fab-button>
						</ion-row>
					</ion-row>
				</ion-item>
			}
			@if (hasEmptyTag(option)) {
				<ion-item
					(click)="increaseOption(option)"
					[class.ion-hide]="option.hidden"
					class="ion-text-wrap ion-no-padding"
					lines="none"
					mode="md"
				>
					<ion-label>{{ option.name | langObservable | async }}</ion-label>
					<ion-checkbox [ngModel]="count(option) > 0" [value]="option" slot="end"></ion-checkbox>
					@if (getPrice(option, ot.STANDARD, preorderType) > 0) {
						<span class="font-max-bold font-14 main-color" slot="end">
							{{
								currency
									? numberToCurrency(getPrice(option, ot.STANDARD, preorderType), currency)
									: getPrice(option, ot.STANDARD, preorderType)
							}}
						</span>
					}
				</ion-item>
			}
		}
	}
	@if (optionGroup.articles.length > 5) {
		<div (click)="showFirstArticles = !showFirstArticles" class="mehr-articles">
			<div>
				<h5>{{ 'common.show_more' | translate }}</h5>
				<ion-icon [class.rotate]="!showFirstArticles" name="chevron-down-outline"></ion-icon>
			</div>
		</div>
	}
</ion-row>
